module.exports = __webpack_public_path__ + "img/1487348317.8ebb1db2.jpg";